import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {BatchStatsDisplay} from '../../service/datamanagement/batchStatsDisplay.js';


/* global customElements */
class BatchWorkGrid extends BaseComponent {
	
	static get properties() {
		return {
			taskId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		this.taskId = false;
		
		var workGrid = this;
		setTimeout(function(){
			workGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var workGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filtercompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (workGrid.taskId ? 'display: none;' : ''),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					postinit: function(combo) {
						Service.getCompanyService().getCompaniesLookup().then(function(data){
							combo.items = data;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},	
				{
					tag: 'vaadin-combo-box',
					label: 'Task Status',
					itemid: 'filterStatus',
					'class': 'spacer-toolbar-item',
					style:(workGrid.taskId ? 'display: none;' : ''),
					name: 'taskStatus',
					'item-value-path': 'code',
					'item-label-path': 'description',
					'keep-open': true,					
					postinit: function (combo) {
						Service.getLookupService().getLookupValues('BatchTaskStatus').then(function (data) {
							combo.items = data;
						});
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
				},	
				{
					tag: 'vaadin-combo-box',
					label: 'Assigned Node',
					itemid: 'filterNode',
					'class': 'spacer-toolbar-item',
					style:(workGrid.taskId ? 'display: none;' : ''),
					name: 'taskType',
					'item-value-path': 'code',
					'item-label-path': 'description',
					'keep-open': true,						
					postinit: function (combo) {
						DataManagementService.getBatchTaskService().getBatchNodes().then(function (data) {
							combo.items = data;
						});
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}
				},											
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'display',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_BATCH_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:lines', ' Display')						
					],
					properties: {
						menu: [
							{
								tag: 'vaadin-item',
								itemid: 'details',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:modal-list"></vaadin-icon> Details',
								listeners: {
									click: function(event) {
										actionShowDetails(grid.selectedItems[0]);
									}
								}
							},
							{
								tag: 'vaadin-item',
								itemid: 'units',
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:truck"></vaadin-icon> Assigned Units',
								listeners: {
									click: function(event) {
										actionShowUnits(grid.selectedItems[0]);
									}
								}
							}
						]
					}					
				}
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{						
					path: 'taskId',
					header: 'Task Id',
					width: '7em'
				},	
				{	
					tag: 'vaadin-grid-column',
					path: 'companyName',
					header: 'Company Name',
					width: '7em'
				},
				{						
					path: 'assignedNode',
					header: 'Assigned Node',
					'text-align': 'center',
					width: '7em'
				},	
				{						
					path: 'batchTaskStatus',
					header: 'Status',
					width: '7em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {						
						root.innerHTML = rowData.item.batchTaskStatusDescription;						
					}
				},
				{	
					tag: 'vaadin-grid-column',
					path: 'stats',
					header: 'Stats',
					resizable: true,
					width: '11em',					
					renderer: function(root, column, rowData) {						
						if (rowData.item.batchStats) {
							var unitsInShard = rowData.item.assignedUnits ? rowData.item.assignedUnits.length : 0;
							var shardLine = unitsInShard > 0 ? unitsInShard + ' unit(s) in shard<br>' : '';
							root.innerHTML = shardLine + BatchStatsDisplay.formatStatsGridHtml(
								rowData.item.batchTaskType,
								rowData.item.batchStats,
								false
							);
						} else {						
							root.innerHTML = '';						
						}
					}
				},
				{
					tag: 'vaadin-grid-column',
					path: 'progress',
					header: 'Progress',
					resizable: true,
					width: '7em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {
						if (rowData.item.startDts) {
							var totalCount = rowData.item.batchStats.totalCount || 0;
							var totalStages = rowData.item.batchStats.totalStages || 0;
							if (totalCount > 0) {
								var dataCount = rowData.item.batchStats.dataCount || 0;
								var percentComplete = dataCount / totalCount;
								root.innerHTML = Math.round(percentComplete * 100) + '%<br><vaadin-progress-bar value="' + (percentComplete) + '"></vaadin-progress-bar>';
							} else if (totalStages > 0) {
								var completedStages = rowData.item.batchStats.completedStages || 0;
								var percentComplete = completedStages / totalStages;
								root.innerHTML = Math.round(percentComplete * 100) + '%<br><vaadin-progress-bar value="' + (percentComplete) + '"></vaadin-progress-bar>';
							} else {
								root.innerHTML = '<vaadin-progress-bar indeterminate value="0"></vaadin-progress-bar>';
							}
						} else {
							root.innerHTML = '<vaadin-progress-bar value="0"></vaadin-progress-bar>';
						}
					}
				},
				{
					tag: 'vaadin-grid-column',
					path: 'runtime',
					header: 'Run Time',
					resizable: true,
					width: '9em',
					renderer: function(root, column, rowData) {
						var startDate = TimeUtil.parseDate(rowData.item.startDts);
						
						var runtime = '-:-:-';
						if (startDate) {
							var millis = (new Date()).getTime() - startDate.getTime();
							runtime = TimeUtil.milliToDisplay(millis);
						}						
						root.innerHTML = runtime;						
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					
					if (grid.selectedItems.length > 0) {					  
						ElementUtil.query(toolbar, 'display').disabled = false; 									
					} else {						
						ElementUtil.query(toolbar, 'display').disabled = true;
					}
				}
			}
		});	
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					workGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'companyName',
						sortOrder: backingGrid.currentSortDirection ? backingGrid.currentSortDirection : 'ASC',
						companyId: ElementUtil.query(toolbar, 'filtercompany').value,
						taskStatus: ElementUtil.query(toolbar, 'filterStatus').value,
						assignedNode: ElementUtil.query(toolbar, 'filterNode').value
					};						
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
															
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					if (workGrid.taskId) {
						DataManagementService.getBatchTaskService().getBatchTaskWork(workGrid.taskId, workGrid.currentFilter)
								.then(function(records){							
							successHandler(records);
						});	
					} else {
						DataManagementService.getBatchTaskService().getAllBatchWork(workGrid.currentFilter)
								.then(function(records){							
							successHandler(records);
						});										
					}
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				pagingToolbar
			]
		});		
		workGrid.append(flexLayout);		
				
		
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		attachWorkspaceFilterState(workGrid, toolbar, ['filtercompany','filterStatus','filterNode'], actionRefresh);
				
		var actionShowDetails = function(workItem) {
			var detailWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Details',
				icon: 'vaadin:modal-list',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						detailWin.show();
						
						var detailTable = ElementUtil.create({
							tag: 'dl-detail-table',
							itemid: 'detailtable',
							slot: 'primary'
						});
						
						var data = [
							{
								key: 'Work Details',
								value: '-',
								section: true
							},	
							{
								key: 'Company Id',
								value: workItem.taskId
							},
							{
								key: 'Company Id',
								value: workItem.companyId
							},
							{
								key: 'Company Name',
								value: workItem.companyName
							},
							{
								key: 'Status',
								value: workItem.batchTaskStatusDescription
							},
							{
								key: 'Assign Node',
								value: workItem.assignedNode
							},																					
							{
								key: 'Data Start Date',
								value: workItem.dataStartDate ? TimeUtil.formatDateStandard(workItem.dataStartDate) : "N/A"
							},
							{
								key: 'Data End Date',
								value: workItem.dataEndDate ? TimeUtil.formatDateStandard(workItem.dataEndDate) : "N/A"  
							},
							{
								key: 'Start Date',
								value: workItem.startDts ? TimeUtil.formatDateStandard(workItem.startDts) : "Not Started"  
							},							
							{
								key: 'Create Date',
								value: TimeUtil.formatDateStandard(workItem.createDts)
							},							
							{
								key: 'Last Update Date',
								value: TimeUtil.formatDateStandard(workItem.updateDts)
							},										
							{
								key: 'Batch Stats',
								value: '-',
								section: true
							},
							{
								key: 'Detail Status',
								value: workItem.batchStats.detailStatus ? workItem.batchStats.detailStatus : "N/A"
							},
							{
								key: 'Stages (completed/total)',
								value: (workItem.batchStats.completedStages || 0) + ' / ' + (workItem.batchStats.totalStages || 0)
							},
							{
								key: 'Total Error',
								value: workItem.batchStats.totalErrors
							},
							{
								key: 'Total Warnings',
								value: workItem.batchStats.totalWarnings
							}						
						];

						var workStatRows = BatchStatsDisplay.buildTaskStatDetailRows(workItem.batchTaskType, workItem.batchStats);
						workStatRows.forEach(function(statRow) {
							data.push(statRow);
						});
											
						detailTable.updateDetails(data);
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								detailTable
							]
						});	
						
						detailWin.addToContentElement(layout);
					}
				}
			});		
		};

		var actionShowUnits = function(workItem) {
			var unitWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Assigned Units',
				icon: 'vaadin:truck',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						unitWin.show();
						
						var unitGrid = ElementUtil.create({
							tag: 'vaadin-grid',
							theme: 'row-stripes column-borders',
							'column-reordering-allowed': '',
							style: 'height: 100%;',			
							slot: 'primary',
							defaults: {
								tag: 'vaadin-grid-sort-column',
								resizable: true
							},			
							children: [									
								{						
									path: 'referenceTypeDescription',
									header: 'Reference Type',									
									width: '7em'
								},
								{						
									path: 'referenceNo',
									header: 'Reference No',									
									width: '7em'
								},
								{						
									path: 'processStartDts',
									header: 'Start Date',									
									width: '7em',
									renderer: function(root, column, rowData) {	
										root.innerHTML = TimeUtil.formatDateStandard(rowData.item.processStartDts);
									}
								},
								{						
									path: 'processEndDts',
									header: 'End Date',									
									width: '7em',
									renderer: function(root, column, rowData) {	
										root.innerHTML = TimeUtil.formatDateStandard(rowData.item.processEndDts);
									}
								},
								{						
									path: 'unitId',
									header: 'Unit Id',									
									width: '7em'
								}
							],
							listeners: {
							}
						});	

						var unitPagingToolbar = ElementUtil.create({
							tag: 'dl-paging-toolbar',
							slot: 'footer',
							pageSize: 250,
							postinit: function(element) {
								element.grid = grid;
								element.loader = function(backingGrid, pageNumber, pagingToolbar) {
									var pageRange = pagingToolbar.pullRange();
									var loadMask = unitGrid.showLoading();

									unitGrid.currentFilter = {
										offset: pageRange.offset,
										max: pageRange.max,
										sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'referenceNo',
										sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC'
									};

									var successHandler = function(records) {
										loadMask.remove();
										unitGrid.activeItem = null;						
										unitGrid.items = records.data;

										unitPagingToolbar.totalRecords = records.totalNumber;
										unitPagingToolbar.updatePager();						
									};

									DataManagementService.getBatchTaskService().getBatchWorkUnits(workItem.workQueueId, unitGrid.currentFilter)
											.then(function(records){							
										successHandler(records);
									});										
								};
							},
							listeners: {
								ready: function() {					
									unitPagingToolbar.loadCurrentPage();					
								}
							}

						});						
						
						var unitFooter = ExportUtil.createExportFooter({
							pagingToolbar: unitPagingToolbar,
							grid: unitGrid,
							itemid: 'batch-work-units',
							onDetail: function() {
								var exportFilter = Object.assign({}, unitGrid.currentFilter || {});
								delete exportFilter.offset;
								delete exportFilter.max;
								DataManagementService.getBatchTaskService().exportBatchWorkUnits(workItem.workQueueId, exportFilter);
							}
						});

						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [							
								unitGrid,
								unitFooter.footerContainer
							]
						});	
												
						unitWin.addToContentElement(layout);
					}
				}
			});
			
		};		
		
		
	}
	
}
customElements.define('dl-batchwork-grid', BatchWorkGrid);
